<div class="column mat-app-background">

  <header>
    <div class="container">
      <app-header></app-header>
    </div>
  </header>

  <nav>
    <app-navbar></app-navbar>
  </nav>

  <main>
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </main>

  <section class="mat-elevation-z4">
    <div class="container">
      <app-trailer></app-trailer>
    </div>
  </section>

  <footer>
    <div class="container">
      <app-footer></app-footer>
    </div>
  </footer>
</div>


